import { Card } from 'react-bootstrap';
import ProgramWindowList from '@/components/common/ProgramWindowList';

/**
 * Each program's application window for the signed-in viewer, including any
 * extension they hold, as decided by the server on the current term.
 */
function ApplicationDeadlineCard({ term }) {
    if (!term?.applicationWindows) return null;

    return (
        <Card
            as="section"
            className="mb-3"
            aria-labelledby="application-deadlines-heading"
        >
            <Card.Body>
                <h2 id="application-deadlines-heading" className="h6 mb-2">
                    Application deadlines
                </h2>
                <ProgramWindowList windows={term.applicationWindows} />
            </Card.Body>
        </Card>
    );
}

export default ApplicationDeadlineCard;
